<template>
  <svg xml:space="preserve" :x="x" :y="y" :width="width" :height="height" class="siesta-svg" @click="missedItem"><image overflow="visible" width="653" height="355" ref="image"></image><ellipse id="item_2_" transform="matrix(0.9339 -0.3574 0.3574 0.9339 -78.7791 88.6314)" fill="#FBAF41" fill-opacity="0.3" stroke="#FFFFFF" stroke-miterlimit="10" cx="200.4" cy="257.5" rx="129.6" ry="46.4" @click="foundItem(0, $event)" v-bind:class="{discovered: isFound(0), hinted: isHinted(0)}"></ellipse><ellipse id="item_3_" fill="#FBAF41" fill-opacity="0.3" stroke="#FFFFFF" stroke-miterlimit="10" cx="61" cy="220.1" rx="47" ry="61.1" @click="foundItem(1, $event)" v-bind:class="{discovered: isFound(1), hinted: isHinted(1)}"></ellipse><ellipse id="item_8_" fill="#FBAF41" fill-opacity="0.3" stroke="#FFFFFF" stroke-miterlimit="10" cx="267.3" cy="310.1" rx="28.7" ry="20.3" @click="foundItem(2, $event)" v-bind:class="{discovered: isFound(2), hinted: isHinted(2)}"></ellipse><ellipse id="item_1_" fill="#FBAF41" fill-opacity="0.3" stroke="#FFFFFF" stroke-miterlimit="10" cx="405.2" cy="182.7" rx="22.8" ry="23.7" @click="foundItem(3, $event)" v-bind:class="{discovered: isFound(3), hinted: isHinted(3)}"></ellipse><ellipse id="item" fill="#FBAF41" fill-opacity="0.3" stroke="#FFFFFF" stroke-miterlimit="10" cx="618" cy="247.5" rx="33" ry="33.8" @click="foundItem(4, $event)" v-bind:class="{discovered: isFound(4), hinted: isHinted(4)}"></ellipse><foreignObject x="0" y="0" v-if="!hasLoaded" :width="width" :height="height"><div class="lds-ring"><div></div><div></div><div></div><div></div></div></foreignObject></svg>
</template>

<script>
export default {
  data() {
    return {
      hasLoaded: false
    }
  },
  methods: {
    foundItem(id, e) {
      e.stopPropagation();
      if (!this.isFound(id) && !this.isHinted(id)) {
        this.$emit("foundItem", id);
      }
    },
    missedItem() {
      this.$emit("missedItem");
    },
    isFound(id) {
      return this.foundItems.includes(id);
    },
    isHinted(id) {
      return this.foundItemsHints.includes(id);
    },
  },
  props: {
    x: Number,
    y: Number,
    width: Number,
    height: Number,
    isLeft: Boolean,
    image: String,
    foundItems: Array,
    foundItemsHints: Array,
  },
  mounted() {
    this.$options.image = new Image();
    this.$options.image.onload = () => {
      this.hasLoaded = true;
      this.$refs.image.href.baseVal = this.image;
      this.$store.state.game.setLoadedImage(this.isLeft);
    }
    this.$options.image.src = this.image;
  },
  beforeDestroy() {
    this.$options.image.onload = null;
  }
};
</script>

<style lang="scss">
</style>

